export default function MentionsLegales() {
  const h1Style = "text-4xl font-bold font-bebas text-orange mb-6";
  const h2Style = "text-3xl font-semibold font-bebas text-rouge mt-6 mb-2";
  const pStyle = "mb-4 text-justify";
  return (
    <section className="relative py-24 px-4 md:px-20 bg-white">
      <h1 className={h1Style}>Crédits et Mentions Légales</h1>

      <p className={pStyle}>
        Merci de lire attentivement les présentes modalités d'utilisation du présent site avant de le parcourir. En visitant ce site, vous acceptez sans réserve ces modalités.
      </p>

      <h2 className={h2Style}>Crédits</h2>
      <p className={pStyle}>
        <strong>Directeur de publication : </strong>Rémi DEMORTIER<br />
        <strong>Développements : </strong>Rémi DEMORTIER<br />
        <strong>Conception graphique : </strong> Julilo Design (
        <a
          href="https://www.julilo.com"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-orange transition-colors duration-500"
        >
          www.julilo.com
        </a>)<br />
        <strong>Hébergement : </strong> OVH, entreprise française spécialisée dans les services cloud computing<br />
        <strong>Photos : </strong>Daniel BANON | Nicolas YONG | Maxime ESCOURROU | Anthony TUGNOLI<br />
      </p>

      <h2 className={h2Style}>Éditeur du site</h2>
      <p className={pStyle}>
        <strong>Festival de Musique d'Ensemble</strong><br />
        <strong>Rémi DEMORTIER</strong><br />
        48 bis rue Louis Plana<br />
        31500 Toulouse<br />
        France<br />
        <a href="https://fme.lagaronne.fr" className="underline text-orange">fme.lagaronne.fr</a><br />
        <a href="mailto:fme@lagaronne.fr" className="underline text-orange">fme@lagaronne.fr</a>
      </p>

      <h2 className={h2Style}>Conditions d'utilisation</h2>
      <p className={pStyle}>
        L'utilisation de ce site est régie par la législation française. Le Festival de Musique d'Ensemble ne saurait être tenu responsable d'une mauvaise utilisation du service.
      </p>

      <h2 className={h2Style}>Limitation de responsabilité</h2>
      <p className={pStyle}>
        Les informations sur ce site sont fournies à titre indicatif et peuvent contenir des inexactitudes ou omissions. Le Festival de Musique d'Ensemble ne peut être tenu responsable de tout dommage direct ou indirect.
      </p>

      <h2 className={h2Style}>Propriété intellectuelle</h2>
      <p className={pStyle}>
        Tout le contenu de ce site (textes, images, vidéos, logos, etc.) est la propriété exclusive du Festival de Musique d'Ensemble. Toute reproduction ou diffusion est interdite sans autorisation écrite.
      </p>
    </section>
  );
}
